'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props as StartReturnAsGuestProps } from './start-return-guest.component';
import dynamic from 'next/dynamic';

const DynamicStartReturnAsGuestComponent: ComponentType<StartReturnAsGuestProps> = dynamic(
  () => import('./start-return-guest.component')
);

export default DynamicStartReturnAsGuestComponent;

export function calculateStartReturnAsGuestPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
